<span>{{ insightsData.total }} {{ 'INSIGHTS.DASHBOARD.REVIEWS' | translate }}</span>
<span class="u-font-size-14 u-color-gray-dark">{{ insightsData.ninetyDaysTotal }} {{ 'INSIGHTS.DASHBOARD.LAST_90_DAYS' | translate }}</span>
